import { createSelector } from 'reselect';
import { getAllsureHomeClaim } from './index';
import { getPurchasePersonalDetailsForm } from './basicDetails';
import { AHOC_REQUIRED_DOCUMENTS, FILE_ICONS } from '../../actions/allsureHomeClaim/types';
import { getClaimName } from './routing';

export const getUploadDocuments = createSelector(
    getAllsureHomeClaim,
    (allsureHomeClaim) => allsureHomeClaim.uploadDocuments
);
export const getUploadDocumentForm = createSelector(getUploadDocuments, (uploadDocuments) => uploadDocuments.form);

export const getDocumentsRequired = createSelector(getUploadDocumentForm, (uploadDocumentsForm) => {
    return Object.keys(uploadDocumentsForm).map((document) => {
        const documentNameKey = document.split('_')[0];
        const imageExtention = uploadDocumentsForm[document].fileName?.split('.')?.slice(-1)[0]?.toLowerCase() ?? null;
        return {
            ...AHOC_REQUIRED_DOCUMENTS[documentNameKey],
            key: document,
            imageUrl: FILE_ICONS[imageExtention],
        };
    });
});

export const getDocumentsArray = createSelector(getUploadDocumentForm, (uploadDocuments) => {
    return Object.values(uploadDocuments);
});

export const getSubmittedAndRequiredDocs = createSelector(getUploadDocumentForm, (uploadDocuments) => {
    const submittedDocuments = [];
    const requiredDocuments = [];
    Object.keys(uploadDocuments).map((document) => {
        if(AHOC_REQUIRED_DOCUMENTS[document] && !['fireReport','technicalReport'].includes(document)){
            uploadDocuments[document].file 
            ? submittedDocuments.push(AHOC_REQUIRED_DOCUMENTS[document].title)
            : requiredDocuments.push(AHOC_REQUIRED_DOCUMENTS[document].title);
        } 
        
    });
    return {
        submittedDocuments,
        requiredDocuments,
    };
});
